module.exports = __webpack_public_path__ + "static/media/gatsby.49bc3bff.png";